import {isFeatureEnabled} from '@github-ui/feature-flags'
import {CreateIssueButton} from '@github-ui/issue-create/CreateIssueButton'
import {TriageAgentButton} from '@github-ui/issue-triage-agent/TriageAgentButton'
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {useNavigate} from '@github-ui/use-navigate'
import {useUser} from '@github-ui/use-user'
import {MilestoneIcon, TagIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'

import {BUTTON_LABELS} from '../../constants/buttons'
import type {AppPayload} from '../../types/app-payload'
import styles from './SearchBarActions.module.css'

type SearchBarActionsProps = {
  isOwnerEnterpriseManaged: boolean
  nameWithOwner: string | null
}

export function SearchBarActions({isOwnerEnterpriseManaged, nameWithOwner}: SearchBarActionsProps) {
  const navigate = useNavigate()
  const {currentUser} = useUser()
  const {scoped_repository, current_user_settings} = useAppPayload<AppPayload>()
  const showTriageAgentButton = scoped_repository && isFeatureEnabled('issues_triage_agent_ux')
  const hideCreateButton =
    scoped_repository?.is_archived || // archived repo
    (currentUser != null && !!currentUser?.is_emu && !isOwnerEnterpriseManaged) // emu user in a non-owned repo

  return (
    <div className={`${styles.buttons} ${styles.gap8} d-flex flex-wrap`}>
      <Button as="a" href={`/${nameWithOwner}/labels`} leadingVisual={TagIcon}>
        Labels
      </Button>
      <Button as="a" href={`/${nameWithOwner}/milestones`} leadingVisual={MilestoneIcon}>
        Milestones
      </Button>
      {showTriageAgentButton && (
        <TriageAgentButton repoOwner={scoped_repository.owner} repoName={scoped_repository.name} />
      )}
      {!hideCreateButton && (
        <CreateIssueButton
          label={BUTTON_LABELS.newIssue}
          navigate={navigate}
          optionConfig={{
            issueCreateArguments: {
              repository: scoped_repository
                ? {
                    owner: scoped_repository.owner,
                    name: scoped_repository.name,
                  }
                : undefined,
            },
            showRepositoryPicker: scoped_repository === null,
            emojiSkinTonePreference: current_user_settings?.preferred_emoji_skin_tone,
            showFullScreenButton: true,
            canBypassTemplateSelection: true,
            navigate,
          }}
        />
      )}
    </div>
  )
}

try{ SearchBarActions.displayName ||= 'SearchBarActions' } catch {}